import "core-js/modules/es.array.push.js";
import request from "../../util/request";
import { ElLoading } from "element-plus";
export default {
  name: "detectionInfo",
  data() {
    return {
      BackDialog: false,
      editform: {},
      dialogFormVisibleEdit: false,
      eqptypeList: [],
      areaList: [],
      areaList2: [],
      areaList3: [],
      areaParentIdOne: '',
      areaParentIdTwo: '',
      areaParentIdThree: '',
      tep: 0,
      //用于点击时改变状态
      // explains: [], //保存现场条件数据
      userName: sessionStorage.getItem("userName"),
      messageText: '不是主检，无操作权限',
      showBack: false,
      //生成备忘录弹窗
      pgList: [],
      current: 0,
      count: 0,
      //点击显示隐藏退出按钮
      instrumentNum: '',
      //仪器组号
      InstrumentStatus: '',
      //仪器状态
      temp: '',
      //温度
      humidity: '',
      //湿度
      voltage: '',
      //电压
      windSpeed: '',
      //风速
      saveName: [],
      //已选择的现场条件或设备信息的内容
      saveID: [],
      //已选择的说明的id
      explainList: [],
      type: 'center',
      msgType: 'success',
      SaveExplainList: [],
      //保存的说明列表
      saveExplainId: [],
      Record: {},
      //记录
      orderAreaDevice: {},
      //工单设备信息
      MaxtiemList: [],
      //模板大项的列表
      moduleList: [],
      //模块名
      detectioncount: [],
      //检测项的总数
      successList: [],
      //检测合格项
      falseList: [],
      //检测不合格项
      vDeviceArea: {},
      //设备信息
      ip: localStorage.getItem("ip"),
      //端口和IP地址
      chickReport: 0,
      //判断是否点击了生成报告
      userAlias: sessionStorage.getItem("userAlias"),
      //姓名
      maxDetailsList: [],
      //保存的大项描述表列表
      meg: '',
      deviceId: "",
      power: "",
      totalmemory: "",
      nowmemory: "",
      totalTmemory: "",
      nowTmemory: "",
      path: "",
      FormData: {},
      selectvalue: '',
      // 当前页
      pageCurrent: 1,
      // 每页数据量
      pageSize: 10,
      // 数据总量
      total: 10
    };
  },
  created() {
    this.getInfo();
    this.queryExplain();
    this.queryDeviceInfo(-1);
  },
  methods: {
    getInfo() {
      var data = sessionStorage.getItem("Record"); //取出缓存数据
      var res = JSON.parse(data);
      this.Record = res;
      if (this.Record.csignDate == null || this.Record.csignDate == "") {
        this.Record.csignDate = this.formatDate(new Date(), "yyyy年MM月dd日");
      }
      if (this.Record.videoUrl != null) {
        if (this.Record.videoUrl.length > 0) {
          this.videoUrl = this.Record.videoUrl;
        }
      }
      var orderAreaDevice = sessionStorage.getItem('orderAreaDevice'); //取出缓存数据
      var resData = JSON.parse(orderAreaDevice);
      this.orderAreaDevice = resData;
    },
    queryDeviceInfo(id) {
      //查询设备信息
      request.get('/detection/queryDecice', {
        params: {
          liftId: this.orderAreaDevice.liftId
          // liftId: 1971
        }
      }).then(res => {
        console.log(res.data);
        this.vDeviceArea = res.data;
        if (id === -1) {
          this.queryMaxTiem();
        }
      });
    },
    //时间格式
    formatDate(value, fmt) {
      let getDate = new Date(value);
      let o = {
        'M+': getDate.getMonth() + 1,
        'd+': getDate.getDate(),
        'h+': getDate.getHours(),
        'm+': getDate.getMinutes(),
        's+': getDate.getSeconds(),
        'q+': Math.floor((getDate.getMonth() + 3) / 3),
        'S': getDate.getMilliseconds()
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length));
      }
      for (let k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
        }
      }
      return fmt;
    },
    //查询检测场景信息
    queryMaxTiem() {
      request.get('/detection/queryMaxTiem', {
        params: {
          TemplateId: this.Record.templateId,
          // TemplateId: 12,
          recId: this.Record.recId
          // recId: 2450
        }
      }).then(res => {
        this.moduleList = [];
        this.detectioncount = []; //检测项的总数
        console.log(res.data);
        this.detectioncount = res.data.countList;
        this.MaxtiemList = res.data.maxtermList;
        this.maxDetailsList = res.data.maxDetailsList;
        this.moduleList = res.data.moduleList;
        this.successList = res.data.successList;
        this.falseList = res.data.falseList;
        for (var i = 0; i < this.detectioncount.length; i++) {
          if (this.detectioncount[i] > 0) {
            let sum = (this.successList[i] + this.falseList[i]) / this.detectioncount[i] * 100;
            this.pgList[i] = Number(sum.toFixed(2));
          }
        }
        console.log(this.detectioncount + "this.detectioncount");
      });
    },
    //查询现场条件
    queryExplain() {
      let vm = this;
      request.post('/detection/queryExplain').then(res => {
        vm.explainList = res.data;
        if (vm.explainList.length > 0) {
          vm.querySaveExplain();
        }
      });
    },
    querySaveExplain() {
      //查询保存的现场条件项
      let vm = this;
      request.get('/detection/querySaveExplain', {
        params: {
          recId: this.Record.recId
          // recId: 2450
        }
      }).then(res => {
        // console.log(res.data);
        vm.SaveExplainList = res.data;
        var items = vm.explainList;
        let values = [];
        values = vm.SaveExplainList;
        // console.log(values + "------values--" + typeof values);
        let list = [];
        if (values != null) {
          this.saveID = [];
          for (var t = 0; t < values.length; t++) {
            list[t] = values[t].explainId;
          }
          for (var i = 0, lenI = items.length; i < lenI; ++i) {
            const item = items[i];
            for (var j = 0; j < values.length; j++) {
              // console.log(111);
              if (values[j].explainId == item.explainId) {
                if (item.explainId == 1) {
                  if (values[j].tempMore != null) {
                    let tempMore = values[j].tempMore.split(",");
                    this.temp = tempMore[0];
                    this.humidity = tempMore[1];
                    this.voltage = tempMore[2];
                  }
                }
                let saveExplainName = item.explainId;
                this.saveID.push(item.explainId);
                this.saveName.push(saveExplainName);
              }
              // console.log(this.saveID + "----this.saveID111");
              // console.log(this.saveName + "----this.saveName");
              this.instrumentNum = values[j].instrumentNum;
              this.InstrumentStatus = values[j].instrumentStatus;
            }
          }
        }
      });
    },
    handleCheckedCitiesChange(value) {
      // let checkedCount = value.length;
      console.log(value);
      this.saveName = this.saveID;
      this.updateSaveExplain();
    },
    getEqpType(EqpType, id) {
      //查询设备类别
      console.log(EqpType, id);
      this.eqptypeList = [];
      request.post('/Device/getEqpType', EqpType).then(res => {
        console.log(res.code + res.mag + res.data + "getEqpType" + res);
        if (res.code === "0") {
          this.eqptypeList = res.data;
        } else {
          this.$message({
            message: "查询设备类别失败",
            type: "error"
          });
        }
      });
    },
    getliftType(lifeKind, id) {
      //查询设备品种
      console.log(lifeKind);
      this.liftTypeList = [];
      request.get('/Device/getliftType?lifeKind=' + lifeKind).then(res => {
        console.log(res.code + res.mag + res.data + "getliftType" + res);
        if (res.code === "0") {
          this.liftTypeList = res.data;
          if (id === 0) {
            // this.form.liftType = '';
          } else {
            for (let i = 0; i < this.liftTypeList.length; i++) {
              if (this.liftTypeList.find(e => e.liftType === this.editform.liftType)) {
                console.log(222);
              } else this.editform.liftType = '';
            }
          }
        } else {
          this.$message({
            message: "查询设备品种失败",
            type: "error"
          });
          this.editform.liftType = '';
          // this.form.liftType = '';
        }
      });
    },

    //修改设备按钮点击事件
    update(row) {
      this.dialogFormVisibleEdit = true;
      this.editform = JSON.parse(JSON.stringify(row));
      this.getEqpType(this.editform.specialType);
      this.getliftType(this.editform.lifeKind, 1);
      request.post('/Device/ParentArea', this.editform.areaId).then(res => {
        console.log(res.data);
        this.areaList = res.data.deviceAreas1;
        for (let i = 0; i < this.areaList.length; i++) {
          if (this.areaList[i].areaId === res.data.areaId1) {
            this.areaParentIdOne = i;
          }
        }
        this.areaList2 = res.data.deviceAreas2;
        for (let i = 0; i < this.areaList2.length; i++) {
          if (this.areaList2[i].areaId === res.data.areaId2) {
            this.areaParentIdTwo = i;
          }
        }
        this.areaList3 = res.data.deviceAreas3;
        for (let i = 0; i < this.areaList3.length; i++) {
          if (this.areaList3[i].areaId === res.data.areaId3) {
            this.areaParentIdThree = i;
          }
        }
      });
    },
    //修改设备数据
    edit(formName) {
      if (!this.validator()) {
        //验证不通过
        return false;
      }
      console.log(formName);
      this.editform.areaId = this.areaList3[this.areaParentIdThree].areaId;
      let device = null;
      device = {
        liftId: this.editform.liftId,
        areaId: this.editform.areaId,
        // dateType: this.editform.dateType,
        unit: this.editform.unit,
        unitCode: this.editform.unitCode,
        loginNum: this.editform.loginNum,
        unitNum: this.editform.unitNum,
        liftType: this.editform.liftType,
        liftModel: this.editform.liftModel,
        liftNum: this.editform.liftNum,
        createUnit: this.editform.createUnit,
        createDate: this.editform.createDate,
        // createDate: this.dateType(this.editform.createDateType, this.editform.createDate),
        createStandard: this.editform.createStandard,
        updateUnit: this.editform.updateUnit,
        updateDate: this.editform.updateDate,
        // updateDate: this.dateType(this.editform.updateDateType, this.editform.updateDate),
        maintenance: this.editform.maintenance,
        superviseDate: this.editform.superviseDate,
        // superviseDate: this.dateType(this.editform.superviseDateType, this.editform.superviseDate),
        superviseType: this.editform.superviseType,
        organ: this.editform.organ,
        erpNum: this.editform.erpNum,
        safety: this.editform.safety,
        safetyNum: this.editform.safetyNum,
        majorUnit: this.editform.majorUnit,
        buildUnit: this.editform.buildUnit,
        majorDate: this.editform.majorDate,
        // majorDate: this.dateType(this.editform.majorDateType, this.editform.majorDate),
        nextDate: this.editform.nextDate,
        // nextDate: this.dateType(this.editform.nextDateType, this.editform.nextDate),
        nextTestDate: this.editform.nextTestDate,
        // nextTestDate: this.dateType(this.editform.nextTestDateType, this.editform.nextTestDate),
        lifeCode: this.editform.lifeCode,
        lifeRegistCode: this.editform.lifeRegistCode,
        lifeKind: this.editform.lifeKind,
        electricModel: this.editform.electricModel,
        bridgeBoxWidth: this.editform.bridgeBoxWidth,
        bridgeBoxDeep: this.editform.bridgeBoxDeep,
        bridgeBoxHigth: this.editform.bridgeBoxHigth,
        pressure: this.editform.pressure,
        speed: this.editform.speed,
        speedUp: this.editform.speedUp,
        speedDown: this.editform.speedDown,
        hcNum: this.editform.hcNum,
        maxPressure: this.editform.maxPressure,
        upStation: this.editform.upStation,
        downStation: this.editform.downStation,
        baseStation: this.editform.baseStation,
        hangType: this.editform.hangType,
        hangNum: this.editform.hangNum,
        flameProof: this.editform.flameProof,
        material: this.editform.material,
        materialSign: this.editform.materialSign,
        testedNum: this.editform.testedNum,
        bufferForm: this.editform.bufferForm,
        safetyGear: this.editform.safetyGear,
        drag: this.editform.drag,
        brakeForm: this.editform.brakeForm,
        hang: this.editform.hang,
        jacking: this.editform.jacking,
        openForm: this.editform.openForm,
        maxWeight: this.editform.maxWeight,
        nominalSpeed: this.editform.nominalSpeed,
        nominalWidth: this.editform.nominalWidth,
        tilt: this.editform.tilt,
        conveying: this.editform.conveying,
        liftingHeight: this.editform.liftingHeight,
        section: this.editform.section,
        controller: this.editform.controller,
        driving: this.editform.driving,
        computer: this.editform.computer,
        assign: this.editform.assign,
        storey: this.editform.storey,
        stand: this.editform.stand,
        door: this.editform.door,
        doorPosition: this.editform.doorPosition,
        testType: this.editform.testType,
        specialType: this.editform.specialType,
        superviseCode: this.editform.superviseCode,
        lifeArea: this.editform.lifeArea,
        propertyName: this.editform.propertyName,
        branchName: this.editform.branchName,
        driveModel: this.editform.driveModel,
        driveCode: this.editform.driveCode,
        controlBoxModel: this.editform.controlBoxModel,
        controlBoxCode: this.editform.controlBoxCode,
        carModel: this.editform.carModel,
        carCode: this.editform.carCode,
        counterweightModel: this.editform.counterweightModel,
        counterweightModelCode: this.editform.counterweightModelCode,
        unitArea: this.editform.unitArea,
        branchArea: this.editform.branchArea,
        propertyArea: this.editform.propertyArea,
        proof: this.editform.proof,
        preDate: this.editform.preDate,
        // preDate: this.dateType(this.editform.preDateType, this.editform.preDate),
        preDateType: this.editform.preDateType,
        updateDateType: this.editform.updateDateType,
        nextDateType: this.editform.nextDateType,
        createDateType: this.editform.createDateType,
        superviseDateType: this.editform.superviseDateType,
        majorDateType: this.editform.majorDateType,
        nextTestDateType: this.editform.nextTestDateType,
        detailArea: this.editform.detailArea
      };
      this.$confirm('是否提交?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.count++;
        if (this.count >= 2) {
          this.$message({
            message: "正在处理...",
            type: "warning"
          });
          return;
        }
        request.post('/Device/update', device).then(res => {
          this.count = 0;
          if (res.code === "0") {
            this.$message({
              message: "编辑成功",
              type: "success"
            });
            this.queryDeviceInfo(1);
            this.dialogFormVisibleEdit = false;
          } else {
            this.$message({
              message: "编辑失败",
              type: "error"
            });
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    validator() {
      //表单验证
      if (this.dialogFormVisibleEdit) {
        //修改
        if (this.editform.specialType === '' || this.editform.specialType === null || this.editform.specialType === undefined) {
          this.$message({
            message: "请选择设备种类",
            type: "warning"
          });
          return false;
        }
        if (this.editform.detailArea === '' || this.editform.detailArea === null || this.editform.detailArea === undefined) {
          this.$message({
            message: "请选择具体地址",
            type: "warning"
          });
          return false;
        } else this.editform.detailArea = this.editform.detailArea.toString().trim();
        if (this.editform.unit === '' || this.editform.unit === null || this.editform.unit === undefined) {
          this.$message({
            message: "请输入使用单位名称",
            type: "warning"
          });
          return false;
        } else this.editform.unit = this.editform.unit.toString().trim();
        if (this.editform.lifeKind === '' || this.editform.lifeKind === null || this.editform.lifeKind === undefined) {
          this.$message({
            message: "请输入设备类别",
            type: "warning"
          });
          return false;
        } else this.editform.lifeKind = this.editform.lifeKind.toString().trim();
        if (this.editform.superviseCode === '' || this.editform.superviseCode === null || this.editform.superviseCode === undefined) {
          this.$message({
            message: "请输入监察识别码",
            type: "warning"
          });
          return false;
        } else {
          this.editform.superviseCode = this.editform.superviseCode.toString().trim();
        }
        if (this.editform.maintenance === '' || this.editform.maintenance === null || this.editform.maintenance === undefined) {
          this.$message({
            message: "请输入维护保养单位",
            type: "warning"
          });
          return false;
        } else this.editform.maintenance = this.editform.maintenance.toString().trim();
      }
      if (this.areaParentIdThree === '' || this.areaParentIdThree === null || this.areaParentIdThree === undefined) {
        this.$message({
          message: "请选择区或镇",
          type: "warning"
        });
        return false;
      }
      return true;
    },
    deleteSaveExplain(Id) {
      //删除保存的现场条件
      let vm = this;
      let map = {
        "saveExplainId": Id
      };
      request.post('/detection/deleteSaveExplain', map).then(res => {
        console.log(res.data);
        vm.addSaveExplain(vm.saveID);
      });
    },
    addSaveExplain(id) {
      //添加保存的现场条件项
      // console.log(id + "---------saveID");
      let tempMore = "";
      tempMore = this.temp + "," + this.humidity + "," + this.voltage;
      let map = {
        "recId": this.Record.recId,
        // "recId": 2450,
        "saveID": id,
        "saveName": this.saveName,
        "tempMore": tempMore,
        "saveDavice": this.saveName,
        "instrumentNum": this.instrumentNum,
        "InstrumentStatus": this.InstrumentStatus
      };
      request.post('/detection/addSaveExplain', map).then(res => {
        console.log(res.data);
      });
    },
    updateSaveExplain() {
      //修改保存的现场条件
      let deleList = [];
      let vm = this;
      request.get('/detection/querySaveExplain', {
        params: {
          "recId": this.Record.recId
          // recId: 2450
        }
      }).then(res => {
        vm.SaveExplainList = res.data;
        if (vm.SaveExplainList != null) {
          for (var i = 0; i < vm.SaveExplainList.length; i++) {
            deleList.push(vm.SaveExplainList[i].saveExplainId);
          }
        }
        vm.deleteSaveExplain(deleList);
      });
    },
    //跳转到检测项
    queryHoistway(name) {
      this.$router.push({
        path: 'Hoistway',
        query: {
          name: name,
          specialType: 1,
          storey: this.vDeviceArea.storey
        }
      });
    },
    toObserved() {
      this.$router.push({
        path: 'Observed',
        query: {
          recId: this.Record.recId
        }
      });
    },
    //保存检测日期
    detectionDateChange: function (e) {
      // this.Record.recDate = e.detail.value;
      this.Record.recDate = e;
      console.log(e);
      let str = null;
      if (this.Record != null && this.Record != "") {
        str = JSON.stringify(this.Record);
      }
      request.get('/detection/updateRecordRecDate', {
        params: {
          "Record": str
        }
      }).then(res => {
        console.log(res.data);
      });
    },
    //保存签收日期
    csDateChange: function (e) {
      // this.Record.recDate = e.detail.value;
      this.Record.csignDate = e;
      console.log(e);
      console.log(this.Record);
      let str = null;
      if (this.Record != null && this.Record != "") {
        str = JSON.stringify(this.Record);
      }
      console.log(typeof str);
      request.get('/detection/updateRecordRecDate', {
        params: {
          "Record": str
        }
      }).then(res => {
        console.log(res.data);
      });
    },
    clickBack() {
      this.BackDialog = true;
    },
    recordBack() {
      //退回
      request.get('/detection/RollbackProcedures', {
        params: {
          recId: this.Record.recId
        }
      }).then(res => {
        console.log(res.data);
        this.BackDialog = false;
        this.$router.push({
          path: 'startDetect'
        });
      });
    },
    toshowToast() {
      //提示还有哪些具体检测项未选择，显示共几项未选择
      if (this.MaxtiemList.length > 0 && this.maxDetailsList.length > 0) {
        if (this.MaxtiemList.length == this.maxDetailsList.length) return true;
        const maxtermIds = this.maxDetailsList.map(e => e.maxtermId);
        let orders = this.MaxtiemList.filter(e => !maxtermIds.includes(e.maxtermId));
        let str = '未检测:';
        for (var i = 0; i < orders.length; i++) {
          if (orders.length > 5 && i < 5) {
            if (orders[i].maxtermKind === '1') {
              str += orders[i].maxtermNo + "*;";
            } else {
              str += orders[i].maxtermNo + ";";
            }
          } else if (orders.length < 5 && i < 5) {
            if (orders[i].maxtermKind === '1') {
              str += orders[i].maxtermNo + "*;";
            } else {
              str += orders[i].maxtermNo + ";";
            }
          }
        }
        this.meg = str + "...等,共" + orders.length + "项未检测";
        // this.$refs.detected.open('top');
        this.$message({
          type: 'warning',
          message: this.meg
        });
      }
    },
    creatReport(id) {
      //点击生成报告按钮
      if (this.vDeviceArea.createStandard == null || this.vDeviceArea.createStandard === undefined || this.vDeviceArea.createStandard === '') {
        this.$message({
          message: "未选择制造执行标准",
          type: "warning"
        });
        return false;
      }
      let b = false;
      let falseB = false;
      if (this.successList.length > 0) {
        for (var i = 0; i < this.successList.length; i++) {
          if (this.successList[i] > 0) {
            b = true;
          }
        }
      }
      if (this.falseList.length > 0) {
        for (let i = 0; i < this.falseList.length; i++) {
          if (this.falseList[i] > 0) {
            falseB = true;
          }
        }
      }
      if (b || falseB) {
        this.toshowToast();
      } else {
        this.$message({
          message: "未选择检测项",
          type: "warning"
        });
        return false;
      }
      if (this.saveID.length == 0) {
        this.$message({
          message: "未选择现场条件",
          type: "warning"
        });
        return false;
      } else {
        this.tocreatReport(id); //生成报告
      }
    },

    tocreatReport(id) {
      this.chickReport = id;
      const loading = ElLoading.service({
        // 打开遮罩层
        lock: true,
        text: '请稍等...',
        background: 'rgba(255, 255, 255, 0.5)'
      });
      let vm = this;
      let map = {
        "recId": this.Record.recId
      };
      //生成报告
      request.post('/detection/report', map).then(res => {
        // console.log(typeof res.data);
        console.log(res.data);
        let record = res.data;
        if (record != null) {
          loading.close(); // 关闭遮罩层
          vm.createRecord(record);
        } else {
          loading.close; //结束加载中
          this.$message({
            message: "生成报告失败",
            type: "error"
          });
        }
      });
    },
    createRecord(record, id) {
      let vm = this;
      let map = {
        "recId": record.recId
      };
      //生成记录pdf
      request.post('/detection/reportquery', map).then(res => {
        // vm.showBack.close; //结束加载中
        if (id === 1) {
          let record = res.data;
          window.open(record.recordUrl);
        } else {
          if (vm.chickReport === 1) {
            let record = res.data;
            // let Record = JSON.stringify(record);
            // sessionStorage.setItem('Record', JSON.stringify(Record))
            // this.$router.push({path: 'RecordPdf', query: {reportUrl: record.reportUrl,tep:0}})
            window.open(record.reportUrl);
          } else {
            vm.updateRecord();
          }
        }
      });
    },
    updateRecord() {
      //修改记录状态
      // let vm = this;
      request.get('/detection/updateRecord', {
        params: {
          Record: this.Record
        }
      }).then(res => {
        console.log(res.data);
        if (res.code === "0") {
          let record = res.data;
          // let Record = JSON.stringify(record);
          // sessionStorage.setItem('Record', JSON.stringify(Record))
          window.open(record.reportUrl);
          this.$router.push({
            path: 'startDetect'
          });
        } else {
          this.$message({
            message: "生成报告失败",
            type: "error"
          });
        }
      });
    },
    //打开备忘录弹窗
    TocreatNotice() {
      this.showBack = true;
    },
    //跳转到备忘录预览页面
    creatNotice() {
      let vm = this;
      let map = {
        "recId": vm.Record.recId,
        "Id": 0,
        "signature": sessionStorage.getItem("imgUrl")
      };
      //生成告知书
      request.post('/detection/notice', map).then(res => {
        let record = res.data;
        window.open(record.noticeUrl);
        this.showBack = false;
      });
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG && !isPNG) {
        this.$message.error('上传签名图片只能是 JPG 或者是 PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传签名图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M || isPNG && isLt2M;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    //上传签名成功后
    handleAvatarSuccess(res, file) {
      // this.resultImg = URL.createObjectURL(file.raw);
      // this.imageUrl = URL.createObjectURL(file.raw);
      console.log(file);
      console.log(file.response);
      sessionStorage.setItem("imgUrl", file.response);
      // this.editform.userSign = file.response.data
    }
  }
};